module.exports = __webpack_public_path__ + "img/logo-claim.a81b5fba.svg";